import {
  HTTP_SELBRANDSPECIAL_FETCHING,
  HTTP_SELBRANDSPECIAL_SUCCESS,
  HTTP_SELBRANDSPECIAL_FAILED,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
//   import { async } from "q";

export const setStateSelBrandSpecialToFetching = () => ({
  type: HTTP_SELBRANDSPECIAL_FETCHING,
});

export const setStateSelBrandSpecialToSuccess = (payload) => ({
  type: HTTP_SELBRANDSPECIAL_SUCCESS,
  payload,
});

export const setStateSelBrandSpecialToFailed = (payload) => ({
  type: HTTP_SELBRANDSPECIAL_FAILED,
});

export const getBrandsSpecial = (companyid) => {
  return async (dispatch) => {
    dispatch(setStateSelBrandSpecialToFetching());
    try {
      const result = await httpClient.get(
        `${server.BRANDSPECIAL_URL}/${companyid}`
      );
      dispatch(setStateSelBrandSpecialToSuccess(result.data));
    } catch (error) {
      dispatch(setStateSelBrandSpecialToFailed());
    }
  };
};
